import { Content } from '../../types';

export const banteayKdeiContent: Content = {
  title: 'מקדש Banteay Kdei - הפנינה החבויה של מתחם אנגקור',
  imageUrl: 'https://tinyurl.com/banteay-kdei-wide',
  introduction: `מקדש Banteay Kdei, הינו אחד האתרים המרתקים במתחם אנגקור שבקמבודיה. המקדש נבנה במאה ה-12 על ידי המלך ג'איאווארמן השביעי, השליט שבנה גם את מקדש Bayon ואת מתחם Ta Prohm. הוא שימש כמרכז בודהיסטי ונבנה בסגנון הבארוק הקמרי, בדומה למבנים אחרים מתקופתו.`,
  sections: [
    {
      title: 'אדריכלות וסגנון בנייה',
      content: `Banteay Kdei בנוי מאבן חול ונושא מאפיינים ייחודיים של הסגנון הבודהיסטי-מהיאני שאפיין את שלטונו של ג'איאווארמן השביעי. המקדש דומה למבנה של Ta Prohm אך קטן וצנוע יותר. הוא מורכב ממספר חצרות פנימיות, אולמות ארוכים ושערים מעוטרים בדמויות מיתולוגיות ובפרצופי ענק, המזוהים עם דמותו של הבודהיסטווה לוקשווארה.

המקדש מוקף בחומה מרובעת וכולל ארבעה שערי כניסה מרשימים, כאשר השער הראשי (המזרחי) הוא המשומר ביותר. ניתן למצוא בו תבליטים מרהיבים של רקדניות אספרות (Apsaras), דמויות אלוהיות מהמיתולוגיה ההינדואית, לצד דימויים בודהיסטיים.`,
      type: 'text-image',
      imageUrl: 'https://tinyurl.com/banteay-kdei-article-1',
    },
    {
      title: 'ההיסטוריה של המקדש',
      content: `למרות יופיו וחשיבותו, Banteay Kdei סבל במהלך השנים מהתדרדרות משמעותית בשל איכות החומרים ששימשו לבנייתו והשפעות האקלים הטרופי. לאחר תקופת הזוהר של האימפריה הקמרית, הוא ננטש ונשאר מוסתר בג'ונגל במשך מאות שנים, עד שהתגלתה מחדש במאה ה-20.`,
      type: 'text',
    },
    {
      title: 'מה לראות במקדש?',
      content: [
        'הכניסה המזרחית - השער הראשי המוביל אל תוך המקדש ומעוטר בפרצופים מרשימים ובתבליטים מפורטים.',
        'החצרות הפנימיות - אזורים בהם ניתן להתרשם מעמודים מסותתים ותקרות אבן מרשימות.',
        'פסלי האפסרות - תבליטים מעודנים של רקדניות המסמלות יופי וחן.',
        'הטבע המשתלט - בדומה ל-Ta Prohm, ניתן לראות עצים שצמחו סביב חלקי המקדש והשתלבו במבנה.',
      ],
      type: 'list',
    },
    {
      title: 'החוויה בביקור במקדש',
      content: `Banteay Kdei הוא אתר פחות מתוייר מאשר אנגקור וואט או Ta Prohm ולכן מעניק חוויית ביקור שקטה ואותנטית יותר. ההליכה בין המסדרונות העתיקים מעניקה תחושה של מסע בזמן, כאשר ניתן לדמיין כיצד חיו והתפללו במקום נזירים בודהיסטים לפני מאות שנים.`,
      type: 'text',
    },
    {
      title: 'מתי כדאי לבקר?',
      content: `הזמן הטוב ביותר לבקר במקדש הוא בשעות הבוקר המוקדמות או אחר הצהריים, כאשר התאורה הטבעית מדגישה את הפרטים הארכיטקטוניים, ויש פחות עומס של תיירים.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, Banteay Kdei הינו מקדש מרתק ומיוחד המשלב בין היסטוריה, ארכיטקטורה ואווירה קסומה. למרות שהוא פחות מפורסם ממקדשים אחרים במתחם אנגקור, הרי שהוא מציע חוויה אינטימית ומרהיבה למבקרים בו. מומלץ להקדיש לו זמן כחלק מהסיור במתחם מקדשי אנגקור וליהנות מהיופי השקט שהוא מציע.`,
      type: 'text',
    },
  ],
};
